import { useState, useEffect } from 'react';
import { campaignService } from '../../backend/services/campaigns';
import type { Campaign, CampaignsFilter } from '../../shared/types/entities';

export const useCampaigns = (filter: CampaignsFilter & { search?: string } = {}) => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCampaigns = async () => {
    console.debug('useCampaigns.fetchCampaigns called with filter:', filter);
    try {
      setLoading(true);
      setError(null);
      console.debug('Calling campaignService.getCampaigns...');
      const data = await campaignService.getCampaigns(filter);
      console.debug('useCampaigns received data:', data.length, 'campaigns');
      setCampaigns(data);
    } catch (err) {
      console.error('Error fetching campaigns:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch campaigns');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaigns();
  }, [filter.status, filter.search]); // Refetch when specific filter params change

  return { campaigns, loading, error, refetch: fetchCampaigns };
};
